import React, { JSX } from "react";
import AppEtapes, { AppEtape } from "src/commun/composants/formNavigation/AppEtapes";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import styles from "./AppEtapeNavigation.scss"

export type AppListeVoletProps = {
  titre: string;
  numeroEtapeInit?: string;
  etapes: AppEtape[];
  setStateListe: (etapes: AppEtape[]) => void;
  contenu: (props: AppEtapeNavigationFunction) => JSX.Element;
  premiereEtape?: number;
} & React.ComponentProps<"div">;

export type AppEtapeNavigationFunction = {
  etapeCourante: string;
  setEtapeCourante: (etape: string) => void;
  pageSuivante: (data: any) => void;
  pagePrecedente: (data: any) => void;
};

// ce composant sert a injectter le page suivante et page précedente.

const AppEtapeNavigation = ({ titre, etapes, setStateListe, contenu, premiereEtape = 0 }: AppListeVoletProps) => {

  // étape courante
  const etape1: string = etapes && etapes.length > 0 ? etapes[premiereEtape].id || "" : "";

  const [etapeCourante, setEtapeCourante] = React.useState(etape1);

  // passage à l'étape suivante
  const pageSuivante = (data: any, result?: any) => {
    // étape suivante
    const nouvelleEtape = getNextEtape(etapeCourante);
    if (!nouvelleEtape) return;

    setStateListe(
      etapes.map(function(item: AppEtape) {
        // si on est sur l'ancienne étape courante
        // on la déselectionne
        // on sauvegarde les données soumises
        // l'état est OK
        //              (rq : avant je passais un état dans la fonction,
        //               ainsi on pouvait avancer d'une page en disant que les données étaient en erreur)
        // on vide les erreurs
        if (item.id === etapeCourante) {
          item.selectionne = false;
          item.data = data;
          item.etat = "OK";
          item.erreur = undefined;
        }
        // pour la nouvelle étape on la sélectionne
        // on passe son état à NA (pour que la css "selectionnée" fonctionne correctement)
        if (item.id === nouvelleEtape) {
          item.selectionne = true;
          if (result) {
            item.data = result;
          }
          item.etat = "NA";
        }
        return item;
      }),
    );
    // sauvegarde de l'étape courante
    setEtapeCourante(nouvelleEtape);
  };

  const pagePrecedente = (etat: "OK" | "KO" | "NF", erreurs?: any) => {
    const nouvelleEtape = getPrecEtape(etapeCourante);
    if (!nouvelleEtape) return;

    // mise à jour de l'état du processus
    setStateListe(
      etapes.map(function(item) {
        // si c'est l'étape qu'on quitte
        // si l'état courant est NA ou si le nouvel état de la page est OK ou KO
        // on applique le nouvel état de la page
        if (item.id === etapeCourante) {
          if (item.etat === "NA" || etat === "OK" || etat === "KO") {
            item.etat = etat;
          }
          // on déslectionne la page
          item.selectionne = false;
          // on sauvegarde les erreurs
          item.erreur = erreurs;
        }
        // étape précédente
        if (item.id === nouvelleEtape) {
          // on sélectionne
          item.selectionne = true;
          // son état passe à NA si l'étape était non finalisée (NF)
          if (item.etat === "NF") item.etat = "NA";
        }
        return item;
      }),
    );
    // on sauvegarde la nouvelle étape
    setEtapeCourante(nouvelleEtape);
  };

  const getNextEtape = (currentId: string) => {
    if (etapes) {
      const idx = etapes.findIndex(etape => etape.id === currentId);
      if (etapes.length > idx + 1) {
        return etapes[idx + 1].id;
      }
    }
    return undefined;
  };

  const getPrecEtape = (currentId: string) => {
    if (etapes) {
      const idx = etapes.findIndex(etape => etape.id === currentId);
      if (idx - 1 >= 0 && etapes.length > idx - 1) {
        return etapes[idx - 1].id;
      }
    }
    return undefined;
  };

  return (
    <>
      <AppRow>
        <AppCol md={{offset: 1, span: 5}} className={styles.navigationTitle}>
          <h1 className={`appTitle`}>{titre}</h1>
        </AppCol>
        <AppCol md={6} className={styles.navigationEtapes}>
          <AppEtapes liste={etapes} />
        </AppCol>
      </AppRow>
      <AppRow className="justify-content-md-center">
        <AppCol md={{span: 11}} className={styles.formContainer}>
          {contenu({
            etapeCourante: etapeCourante,
            setEtapeCourante: setEtapeCourante,
            pageSuivante: pageSuivante,
            pagePrecedente: pagePrecedente,
          })}
        </AppCol>
      </AppRow>
    </>
  );
};

export default AppEtapeNavigation;
